/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Keen_Otter_SwimInputs */

const en_bold_keen_otter_swim = /** @type {(inputs: Bold_Keen_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select attribute...`)
};

const de_bold_keen_otter_swim = /** @type {(inputs: Bold_Keen_Otter_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmal auswählen...`)
};

/**
* | output |
* | --- |
* | "Select attribute..." |
*
* @param {Bold_Keen_Otter_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_keen_otter_swim = /** @type {((inputs?: Bold_Keen_Otter_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Keen_Otter_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_keen_otter_swim(inputs)
	return de_bold_keen_otter_swim(inputs)
});